import React, { useCallback } from 'react'
import {
  ProgressIndicator,
  type ProgressIndicatorProps,
} from '~/components/progress-indicator'
import {
  DISPLAY_NAME,
  type SnackbarScopedProps,
  useSnackbarContext,
} from '../../snackbar'
import type { SnackbarTypes } from '../../snackbar.types'
import { SnackbarTimebarVariants } from './snackbar-timebar.styles'

type SnackbarTimeBarProps = {}

export const SnackbarTimeBar = (props: SnackbarTimeBarProps) => {
  const { __scopeSnackbar } = props as SnackbarScopedProps<SnackbarTimeBarProps>
  const {
    duration = 5000,
    type,
    isPaused,
  } = useSnackbarContext(DISPLAY_NAME, __scopeSnackbar)

  const mapper: Record<SnackbarTypes, ProgressIndicatorProps['variant']> = {
    success: 'success',
    informative: 'informative',
    warning: 'warning',
    danger: 'danger',
    'brand-accent': 'brand',
  }

  const [percentage, setPercentage] = React.useState(0)

  React.useEffect(() => {
    if (isPaused) return

    const interval = setInterval(() => {
      setPercentage(prev => {
        const nextValue = prev + 100 / (duration / 100)
        return Math.min(nextValue, 100)
      })
    }, 100)

    return () => clearInterval(interval)
  }, [isPaused, duration])

  const mapVariantColor = useCallback((): ProgressIndicatorProps['variant'] => {
    return mapper[type]
  }, [type])

  return (
    <div className={SnackbarTimebarVariants({})} data-testid="snackbar-timebar">
      <ProgressIndicator
        percentage={percentage}
        bgTransparent
        size="nano"
        variant={mapVariantColor()}
      />
    </div>
  )
}
